(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const menuSelector = '.header__inline-menu > .list-menu--inline > li > header-menu';
  const hoverOpenedAttribute = 'data-custom-desktop-hover-opened';
  const closeDelay = 120;

  const setExpanded = (details, expanded) => {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(expanded));
  };

  const closeDetails = (details) => {
    details.removeAttribute('open');
    details.removeAttribute(hoverOpenedAttribute);
    setExpanded(details, false);
  };

  const closeHoverOpenedDetails = (container) => {
    container.querySelectorAll(`details[${hoverOpenedAttribute}]`).forEach(closeDetails);
  };

  const openDetails = (details) => {
    if (!details.open) {
      details.setAttribute(hoverOpenedAttribute, '');
      details.setAttribute('open', '');
    }
    setExpanded(details, true);
  };

  const initializeMenu = (headerMenu) => {
    if (headerMenu.dataset.customDesktopHoverReady === 'true') return;

    const mainDetails = headerMenu.querySelector(':scope > details');
    if (!mainDetails) return;

    headerMenu.dataset.customDesktopHoverReady = 'true';
    let closeTimer;

    headerMenu.addEventListener('pointerenter', () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(closeTimer);

      document.querySelectorAll(menuSelector).forEach((otherMenu) => {
        if (otherMenu !== headerMenu && !otherMenu.contains(document.activeElement)) {
          closeHoverOpenedDetails(otherMenu);
        }
      });

      openDetails(mainDetails);
    });

    headerMenu.addEventListener('pointerleave', () => {
      if (!desktopHover.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!headerMenu.matches(':hover') && !headerMenu.contains(document.activeElement)) {
          closeHoverOpenedDetails(headerMenu);
        }
      }, closeDelay);
    });

    headerMenu.querySelectorAll('details details').forEach((nestedDetails) => {
      nestedDetails.addEventListener('pointerenter', () => {
        if (!desktopHover.matches) return;
        openDetails(nestedDetails);
      });

      nestedDetails.addEventListener('pointerleave', () => {
        if (!desktopHover.matches || nestedDetails.contains(document.activeElement)) return;
        closeDetails(nestedDetails);
      });
    });
  };

  const initialize = () => document.querySelectorAll(menuSelector).forEach(initializeMenu);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  desktopHover.addEventListener('change', (event) => {
    if (event.matches) {
      initialize();
      return;
    }

    document.querySelectorAll(menuSelector).forEach(closeHoverOpenedDetails);
  });
})();
